import { Role, userRolesIndex } from 'utils/helpers/auth0.helpers';
import { Auth0UserState } from 'hooks/useAuth0User';

export const systemAdminRoles: Role[] = [Role.MkSystemAdmin, Role.MkSystemOperator];

export const supplierRoles: Role[] = [Role.Admin];

export const hospitalRoles: Role[] = [Role.SaviConnectManager, Role.SaviConnectUser, Role.SaviConnectViewer];

export const getUserRoles = (user: Auth0UserState): Role[] => {
  if (!user?.isAuthenticated) {
    return [];
  }

  return user[userRolesIndex] || [];
};

/**
 *
 * @param userRoles
 * @param rolesWithPermission
 * @returns
 */
export const userHasPermissions = (user?: Auth0UserState, rolesWithPermission: Role[] = []): boolean => {
  if (!user?.isAuthenticated) {
    return false;
  }

  if (rolesWithPermission.length < 1) {
    return true;
  }

  return !!getUserRoles(user).some(userRole => rolesWithPermission.includes(userRole));
};

/**
 *
 * @param user
 * @returns whether the user is an system admin
 */
export const isSystemAdmin = (user: Auth0UserState): boolean =>
  user.isAuthenticated && userHasPermissions(user, systemAdminRoles);
/**
 *
 * @param user
 * @returns whether the user is a supplier
 */
export const isSupplier = (user: Auth0UserState): boolean =>
  user.isAuthenticated && userHasPermissions(user, supplierRoles);

/**
 *
 * @param user
 * @returns whether the user is a hospital viewer
 */
export const isHospitalViewer = (user: Auth0UserState): boolean =>
  user.isAuthenticated && userHasPermissions(user, [Role.SaviConnectViewer]);

/**
 *
 * @param user
 * @returns whether the user is a reviewer
 */
export const isInOrg = (user: Auth0UserState): boolean => {
  return user.isAuthenticated && user.org_id === process.env.REACT_APP_AUTH0_MK_ORGANIZATION;
};
